import { createFileRoute } from '@tanstack/react-router'
import { CustomerCommunicationsPage } from '@/pages/customer-communications'

export const Route = createFileRoute('/_authenticated/customer-comms/')({
  staticData: { title: 'Customer Comms' },
  component: CustomerCommunicationsPage,
})
